import React, { useState, useEffect } from "react";
import "./Testimonials.css";

/**
 * Testimonials component
 * - Uses .about-banner style for the heading so it matches About/Contact/Services
 * - Simple prev/next navigation and dots
 * - Replace avatar/image urls or text with real website content
 */

const TESTIMONIALS = [
  

  {
    id: 1,
    title: "Outstanding Project Oversight",
    quote:
      "The inspection team demonstrated exceptional professionalism and dedication throughout our project. Their clear communication, timely reporting, and precise technical evaluations ensured smooth progress without delays.",
    name: "Client Representative",
    role: "Infrastructure Project",
    rating: 5,
  },
  {
    id: 2,
    title: "Highly Dependable & Efficient",
    quote:
      "Their coordination, follow-ups, and on-site expertise were remarkable. The team proactively identified issues and provided practical solutions that significantly improved project efficiency.",
    name: "Project Manager",
    role: "Industrial Construction",
    rating: 5,
  },
  {
    id: 3,
    title: "Exceptional Technical Expertise",
    quote:
      "The inspections were carried out with great accuracy and attention to detail. Their systematic approach and commitment to quality played a key role in ensuring successful project execution.",
    name: "Senior Engineer",
    role: "Civil & Structural Works",
    rating: 4,
  },
  {
    id: 4,
    title: "Smooth Execution & Strong Support",
    quote:
      "From day one, the team showed strong ownership and reliability. Their consistent communication and professionalism helped maintain clarity and confidence across all stakeholders.",
    name: "Operations Lead",
    role: "Engineering Services",
    rating: 5,
  },
  {
    id: 5,
    title: "Reliable & Quality-Focused Team",
    quote:
      "Their collaborative approach and thorough inspection practices made a significant positive impact. The team delivered exactly what was expected with high standards of quality and safety.",
    name: "Quality Supervisor",
    role: "Construction Monitoring",
    rating: 4,
  },
  
];

export default function Testimonials() {

  // Set Browser Tab Title for Testimonials Page
  useEffect(() => {
    document.title = "Testimonials | Qnexa Services — Trusted by Industry Leaders";
  }, []);

  const [index, setIndex] = useState(0);
  const t = TESTIMONIALS[index];

  function prev() {
    setIndex((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  }
  function next() {
    setIndex((i) => (i + 1) % TESTIMONIALS.length);
  }
  function goTo(i) {
    setIndex(i);
  }

  return (
    <section className="testimonials-section">
      {/* Banner that matches About/Services (use your global .about-banner if present) */}
      <div className="about-banner">
        <h1>Testimonials</h1>
      </div>

      <div className="testimonials-wrap">
        <button
          className="nav-arrow left"
          aria-label="Previous testimonial"
          onClick={prev}
        >
          ‹
        </button>

        <div className="testimonial-card">
          <h3 className="testimonial-title">{t.title}</h3>

          <p className="testimonial-quote">“{t.quote}”</p>

          <div className="testimonial-author">
            <strong>{t.name}</strong>
          </div>

          <div className="testimonial-role">{t.role}</div>

          <div className="rating">
            {Array.from({ length: 5 }).map((_, i) => (
              <span
                key={i}
                className={`star ${i < t.rating ? "filled" : ""}`}
                aria-hidden
              >
                ★
              </span>
            ))}
          </div>

          <div className="dots">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === index ? "active" : ""}`}
                onClick={() => goTo(i)}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>
        </div>

        <button
          className="nav-arrow right"
          aria-label="Next testimonial"
          onClick={next}
        >
          ›
        </button>
      </div>
    </section>
  );
}
